// @flow

import { useSearchParams } from 'react-router-dom';

import { selectFeatureFlag } from '@gandi/authentication';

import { useAppSelector } from './useAppSelector';
import { useHasMounted } from './useHasMounted';

export const useFeatureFlag = (
  featureFlagName: StringPrefix<'FF_'> | StringPrefix<'ff-'>,
): boolean => {
  const featureFlag = useAppSelector((state): boolean =>
    selectFeatureFlag(state, { featureFlagName }),
  );

  const hasMounted = useHasMounted();
  const [searchParams] = useSearchParams();

  const hasFFOverride = /ff-|FF_/.test(searchParams.toString());

  // Force a 2-pass render to fix DOM attributes patching
  // if the URL contains query parameters that might override the flag,
  // to avoid hydration issues.
  // This is needed because the query parameters are only read on the client side for now.
  if (!hasMounted && hasFFOverride) {
    return false;
  }

  return featureFlag;
};
